// extracted by mini-css-extract-plugin
export default {"styleChooserSection":"h1-z","dimensionLabel":"i1-z","styleChooserControlWrapper":"j1-z","styleChooserControl":"k1-z","disabled":"l1-z","giftCard":"m1-z","styleChooserText":"n1-z"};